import {
  SearchFilterConfig,
  HasTenantResource,
  ResourceConfig,
  RailsUpdateTrackingResource
} from "@hidat/huijs-resource";
import {FieldConfig, FieldDataTypes, ModelInterface, uString, Uuid} from "@hidat/huijs-common";
import {RblResourceInterface} from "../rbl-resource.interface";

export const ArtistNameConfig = new ResourceConfig('ArtistName', 'artists', true, true)
    .addFields([
        new FieldConfig('name'),
        new FieldConfig('artistTrackCount', FieldDataTypes.INTEGER),
        new FieldConfig('albumArtistTrackCount', FieldDataTypes.INTEGER),
    ])
    .setSorts({
        name: "name"
    })
    .setDefaultSort('name')

export interface ArtistNameInterface extends ModelInterface, RailsUpdateTrackingResource, HasTenantResource {
  id: Uuid | undefined;
    name: uString;
    artistTrackCount: number | undefined;
    albumArtistTrackCount: number | undefined;
}

export const ArtistNameFilterConfig = new SearchFilterConfig(ArtistNameConfig, { only: ['name']});

